import { Link } from "react-router-dom";
import Report from "./../images/report.png"
import Search from "./../images/search.png"
import Server from "./../images/server.png"
import ArrowRight from "./../images/arrow-right.png"

import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";

const Home = () => {

    // functions from App component
    // to transit values of JWT and errors to App component
    const { setAlertClassName } = useOutletContext();
    const { setAlertMessage } = useOutletContext();

    // delete all the previous errors
    useEffect(() => {
        setAlertClassName("d-none"); // hide alert if it was
        setAlertMessage("");
    }, [setAlertClassName, setAlertMessage]);

    return (
        <>
            <div className="text-center mt-5 ">
                <h1 className="display-3">Welcome!</h1>
                <h4>Search, follow and analyze information in headlines</h4>
                <hr />
                <br />
                <Link to="/search"><h2><span className="badge bg-primary mt-3">Search</span></h2></Link>
                <br />
                <div className="row mt-5">

                    <div className="col-3">
                        <img src={Search} alt="movie-tickets"></img>
                        <h5 className="mt-3">Every day we scan <strong>hundreds sources</strong> of information</h5>
                    </div>

                    <div className="col-1">
                        <img src={ArrowRight} alt="movie-tickets"></img>
                    </div>

                    <div className="col-4">
                        <img src={Server} alt="movie-tickets"></img>
                        <h5 className="mt-3"><strong>Collect</strong> and analyze <strong>headlines</strong></h5>
                    </div>

                    <div className="col-1">
                        <img src={ArrowRight} alt="movie-tickets"></img>
                    </div>

                    <div className="col-3">
                        <img src={Report} alt="movie-tickets"></img>
                        <h5 className="mt-3">Prepare <strong>reports</strong> on your request</h5>
                    </div>

                    <Link to="/about" className="mt-5 link-secondary"><span>More information here</span></Link>
                </div>
            </div>
        </>
    )
}

export default Home;